function ProductMark({ label }) {
  return (
    <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-border bg-surface text-xs font-semibold text-primary transition-all duration-200 ease-in-out">
      {label}
    </span>
  );
}

export default ProductMark;
